/* created by CoolGuy on 2018/12/13 */
import request from "../utils/request";
import commonApi from "./common";
import { IPreCreate, ICreate } from "../store/RedPackStore.d";
import { IResult } from "../global";

interface IBindPhone {
  phone: string;
  galleryid: string;
  content: string;
  code: string;
  nickname: string;
}

const redpack = {
  gettime: commonApi.gettime,
  sendsms: commonApi.sendsms,
  bindphone: ({ phone, galleryid, content, code, nickname }: IBindPhone) => {
    return new Promise<IResult>((resolve, reject) => {
      if (!galleryid) {
        reject();
        console.error("gallery id is null!");
        return;
      }
      request({
        url: "/api/v2/wxuser/bindphone",
        method: "post",
        data: { phone, galleryid, content, code, nickname },
        headers: {
          Authorization: request.token,
        },
      })
        .then((jsonData) => {
          resolve(jsonData);
        })
        .catch(reject);
    });
  },
  getdetail: (galleryid: string) => {
    return new Promise<IResult>((resolve, reject) => {
      if (!galleryid) {
        reject();
        console.error("gallery id is null in getdetail");
        return;
      }
      request({
        url: "/api/v2/redpackage/list",
        method: "get",
        data: { galleryid },
        headers: {
          Authorization: request.token,
        },
      })
        .then((jsonData) => {
          resolve(jsonData);
        })
        .catch(reject);
    });
  },
  getredpack: (id: number) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: "/api/v3/redpackage/get",
        method: "post",
        data: { id },
        headers: {
          Authorization: request.token,
        },
      })
        .then((jsonData) => {
          resolve(jsonData);
        })
        .catch(reject);
    });
  },
  askredpack: (id: number) =>
    new Promise<IResult>((resolve, reject) => {
      request({
        url: "/api/v3/redpackage/ask",
        method: "post",
        data: { id },
        headers: {
          Authorization: request.token,
        },
      })
        .then((jsonData) => {
          resolve(jsonData);
        })
        .catch(reject);
    }),
  getredpackdetail: (id: number, page = 1) =>
    new Promise<IResult>((resolve, reject) => {
      request({
        url: "/api/v2/redpackage/detail",
        method: "get",
        data: { id, page },
        headers: {
          Authorization: request.token,
        },
      })
        .then((jsonData) => {
          resolve(jsonData);
        })
        .catch(reject);
    }),
  precreate: ({ amount, galleryid }: IPreCreate) =>
    new Promise<IResult>((resolve, reject) => {
      request({
        url: "/api/v2/redpackage/precreate",
        method: "post",
        data: { amount, galleryid },
        headers: {
          Authorization: request.token,
        },
      })
        .then((jsonData) => {
          resolve(jsonData);
        })
        .catch(reject);
    }),
  create: ({
    number = 1,
    amount = 0,
    type = "normal",
    content = "",
    tradeid = "",
    galleryid,
  }: ICreate) =>
    new Promise<IResult>((resolve, reject) => {
      request({
        url: "/api/v2/redpackage/create",
        method: "post",
        data: { number, amount, type, content, tradeid, galleryid },
        headers: {
          Authorization: request.token,
        },
      })
        .then((jsonData) => {
          resolve(jsonData);
        })
        .catch(reject);
    }),
};

export default redpack;
